export default __webpack_public_path__ + "static/media/upload_fail_icon.ae036ada.png";